import { render, staticRenderFns } from "./base-dialog.vue?vue&type=template&id=146f6762&scoped=true"
import script from "./base-dialog.vue?vue&type=script&lang=js"
export * from "./base-dialog.vue?vue&type=script&lang=js"
import style0 from "./base-dialog.vue?vue&type=style&index=0&id=146f6762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f6762",
  null
  
)

export default component.exports